import React from 'react';
import useArticles from '../hooks/useArticles';
import BlogCtaSection from './blog/components/BlogCtaSection';
import BlogHeroSection from './blog/components/BlogHeroSection';
import BlogHighlightsSection from './blog/components/BlogHighlightsSection';
import BlogLatestPostsSection from './blog/components/BlogLatestPostsSection';
import { BLOG_HIGHLIGHTS } from './blog/constants';

const Blog = () => {
  const { articles: posts, status: postsStatus } = useArticles(3);

  return (
    <>
      <BlogHeroSection />

      <div className="site-bg-section py-20 px-6">
        <div className="container mx-auto">
          <BlogLatestPostsSection posts={posts} postsStatus={postsStatus} />
          <BlogHighlightsSection highlights={BLOG_HIGHLIGHTS} />
          <BlogCtaSection />
        </div>
      </div>
    </>
  );
};

export default Blog;
